var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SharePanel',{attrs:{"layerName":_vm.layerName,"hasRedPacket":false,"pageSource":"icsapp","shareChannelNames":['weixin', 'weixincircle']},on:{"share":_vm.goShare}})}
var staticRenderFns = []

export { render, staticRenderFns }